export default {
  path: '/other',
  component: () => import('../components/Index'),
  children: [
    {
      path: "player",
      meta: {
        hideHeader: true,
        hideFotter: true,
      },
      component: () => import('../components/other/Player'),
    },
  ],
}



// WEBPACK FOOTER //
// ./src/pages/pc/router/other.js